import React, {useState, useEffect} from "react";
import Section from "../layouts/Section";
import {WebLink, SiteWide} from "../customComponents";
import { useSelector, useDispatch } from 'react-redux';

import {authActions} from '../../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect} from '../../redux/selectors/index';
import Helper1, {notify, money, customNormalModalStyles} from '../../utility/Helper1';
import {homepage} from '../../utility/APIRequests';


import Countdown from 'react-countdown';

import copy from 'copy-to-clipboard';
import {staticCountries} from '../../utility/countries';
import {Images} from "../customComponents";
import Slider from "react-slick";
import { RiFileCopyLine, RiPhoneLockFill, RiBankFill,RiStackshareLine, RiWallet3Fill, RiArrowGoBackLine, RiEarthLine, RiLockUnlockLine, RiAccountBoxFill, RiSecurePaymentLine, RiListOrdered, RiLockPasswordFill, RiLoginBoxFill, RiMouseLine } from "react-icons/ri";
import QRCode from "react-qr-code";
import {systemColor} from '../../utility/styles';
import parse from 'html-react-parser';
import DownModal from "../layouts/DownModal";


function RefLink({history}){

    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const finance = useSelector(homeScreenStatSelect);

    const systemColorManager = systemColor()
    
    const [selectedLevel, setSelectedLevel]   = useState(1);
    const [invitationCodeModal, setInvitationCodeModal]   = useState(false);

    const dispatch = useDispatch();

    const copyRefLink = () => {
        notify('Referral Link Copied', 1)
    }


    const myRefCode = userData?.myrefid
    const myRefLink = site_settings?.site_settings?.site_url+'/#/signup?ref='+ myRefCode

    
    const toggleInviteModal = () => {
        setInvitationCodeModal(!invitationCodeModal)
    }


    const copyThis = (itemToCopy) => {
        copy(itemToCopy)
        notify('Copied', 1)
    }

    return (
        <SiteWide title={`Invite Friends`}>
                
            
            <Images style={{borderRadius: 10}} source={site_settings.image_settings?.[0]?.image4} alt="Referral Commission" />




                <div className="" style={{ overflowX: "scroll", marginTop: 20}}>
                    {site_settings?.referral_settings?.length > 1 && <div style={{ display: "flex" }}>
                        {site_settings?.referral_settings?.map((item, i) => {
                            
                            let thisCount = i+1
                            let backg = (selectedLevel==thisCount)?systemColorManager.btn_2:systemColorManager.no_bg

                            return <div onClick={() => setSelectedLevel(thisCount)} key={i} className="flexify" style={{cursor: 'pointer', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', borderRadius: 5, minWidth: 80, height: 80, 
                                ...backg, marginRight: 5, ...systemColorManager.borders_color, ...systemColorManager.txt_1}} >
                                <Images width={20} height={20} source={item[`image_${thisCount}`]} />
                                {parse(item[`name_for_level_${thisCount}`])}
                            </div>

                        })}
                    </div>}
                </div>




                <div style={{marginTop: 20, ...systemColorManager.txt_1}}>
                    {parse(site_settings?.referral_settings?.[selectedLevel-1]?.[`note_for_level_${selectedLevel}`])}
                </div>

                
                <div style={{...systemColorManager.txt_1, marginTop: 20}}>

                    <button style={{...systemColorManager.btn_5, ...systemColorManager.txt_3}} className="btn btn-info btn-block cursor-pointer flexify" onClick={() => copyThis(myRefLink)}>Copy Referral Link <RiFileCopyLine /></button>

                    <button style={{...systemColorManager.btn_5, ...systemColorManager.txt_3}} className="btn btn-info btn-block cursor-pointer flexify" onClick={() => copyThis(myRefCode)}>Copy Invite Code <RiFileCopyLine /></button>
                    
                    <button style={{...systemColorManager.btn_5, ...systemColorManager.txt_3}} className="btn btn-info btn-block cursor-pointer" onClick={toggleInviteModal}>Scan QR code</button>

                </div>



                <DownModal containerStyle={{...systemColorManager.bg_1}} isOpen={invitationCodeModal} onClose={toggleInviteModal}>
                
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <div className="" style={{maxHeight: 'auto', width: '90%'}}>

                            <div className="text-center" style={{padding: 1, paddingBottom: 20}}>
                                
                                <div style={{backgroundColor: '#fff', paddingLeft: 6, paddingRight: 6, paddingTop: 6, paddingBottom: 0, display: 'inline-block'}}>
                                    <QRCode bgColor="#fff" value={myRefLink} />
                                </div>

                            </div>

                        </div>
                    </div>
                </DownModal>



        </SiteWide>
    );

}

export default RefLink;